import React from 'react';

import BaseErrorToast from './BaseErrorToast';

type TMaximumTotalLimitProps = {
    equipmentName: string,
}

const MaximumTotalLimit = ({ equipmentName, ...props }: TMaximumTotalLimitProps) => <BaseErrorToast {...props}>
    <>
        Вы&nbsp;достигли лимита по&nbsp;количеству {equipmentName} в&nbsp;заявке. Удалите что-нибудь, чтобы добавить новый.
    </>
</BaseErrorToast>;

export default MaximumTotalLimit;
